export default "__VITE_ASSET__e8893277__"